import styled from '@emotion/styled'
import tw from 'twin.macro'

export const ChangeLink = styled.a`
  ${tw`mt-3 md:mt-0 no-underline cursor-pointer text-pretRed-700 inline focus:outline-none focus:shadow-outline`}
`
